import {
  INSTALLATION_FEE,
  DRY_FIT_BAND_PRICES,
  WET_FIT_BAND_PRICES,
} from '../../brands/magnet/prices'
import { CABINET_TYPES, UNIT_TYPE } from './constants'

const createFormatter = (countryCode, currency, digits) =>
  new Intl.NumberFormat(countryCode, {
    style: 'currency',
    currency,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })

export const formatPrice = ({
  price,
  country = { code: 'en-GB', currency: 'GBP' },
  startingText,
  digits = 0,
}) => {
  const formatter = createFormatter(country.code, country.currency, digits)
  return `${(price && startingText) || ''}${
    price !== undefined ? formatter.format(price) : ''
  }`
}

export const getPrice = (card, selection, context) => {
  if (card.id === 'range' || card.id === 'cabinet') return 0
  if (card.id === 'units') {
    const { prices, handlelessPrices, prebuiltPrices, showHandleSelection } =
      selection.range
    const isHandleless = selection.range.option?.key === 1
    const isPreBuilt = selection.cabinet?.type === CABINET_TYPES.PRE_BUILT

    if (handlelessPrices && showHandleSelection && isHandleless) {
      return handlelessPrices[card.type] || 0
    }

    if (isPreBuilt && prebuiltPrices) {
      return prebuiltPrices[card.type] || 0
    }

    return prices[card.type] || 0
  }
  if (card.id === 'installation' && card.storeBand) {
    return getInstallationPrice(
      card.cardType || 0,
      selection.units?.type || '',
      card.storeBand,
      card.hasChargedFee || false
    )
  }
  if (
    card.id === 'worktops' ||
    card.id === 'installation' ||
    card.id === 'flooring'
  ) {
    if (card.title === 'No flooring') {
      return card.price
    }
    const size = selection.units.type
    return card.prices[size]
  }
  if (card.id === 'storage') {
    if (context === undefined) return 0
    let storagePrice = 0
    for (let i = 0; i < context.cards.length; i += 1) {
      storagePrice += context.cards[i].amount * context.cards[i].price
    }
    return storagePrice
  }
  if (card.id === 'sinks' && card.option) {
    if (card.prices === null) return card.price
    return card.prices[0][card.option.key]
  }
  if (card.id === 'appliances' && card.option) {
    if (card.title === 'No appliances') {
      return card.price
    }
    if (card.prices === null) return card.price

    return card.prices[0][card.option.key]
  }
  return card.price
}

export const getInstallationPrice = (
  cardType,
  unitType,
  storeBand,
  hasChargedFee
) => {
  if (cardType === 0 || !storeBand || !unitType) {
    return 0
  }

  const prices = cardType === 1 ? DRY_FIT_BAND_PRICES : WET_FIT_BAND_PRICES
  const index = UNIT_TYPE[unitType] ?? 0
  const fee = hasChargedFee ? INSTALLATION_FEE : 0
  const price = prices[storeBand]?.[index]

  if (!price) {
    return 0
  }

  return price + fee
}

export const getCabinetPrice = (card, selection) => {
  const { handlelessPrices, prebuiltPrices, showHandleSelection, prices } =
    selection.range
  const isHandleless = selection.range.option?.key === 1
  const isPreBuilt = card.type === CABINET_TYPES.PRE_BUILT
  const unitType = selection.units?.type

  if (!unitType) {
    return 0
  }

  if (handlelessPrices && showHandleSelection && isHandleless) {
    return 0
  }

  if (isPreBuilt && prebuiltPrices) {
    const prebuiltPrice = prebuiltPrices[unitType] || 0
    const price = prices?.[unitType] || 0

    if (prebuiltPrice <= price) {
      return 0
    }

    return prebuiltPrice - price
  }

  return 0
}

export const getFormatedPrice = ({
  card,
  selection,
  startingText,
  country,
  context,
}) =>
  formatPrice({
    price: getPrice(card, selection, context),
    startingText,
    country,
  })

export const checkHideFlatPack = (selection) => {
  if (!selection?.range) {
    return false
  }

  const { title: rangeTitle, option, handles } = selection.range
  const PREBUILT_ONLY_RANGE_TITLES = ['Bewdley', 'Reed']
  const isOnlyPrebuiltType = PREBUILT_ONLY_RANGE_TITLES.includes(rangeTitle)
  const isOnlyHandlelessType = handles?.[0]?.key === 1
  const isHandleless = !isOnlyHandlelessType && option?.key === 1

  return isHandleless || isOnlyPrebuiltType
}

export const getInstallationText = ({ card, selectionItem }) => {
  if (!card || !selectionItem) return ''

  const installationItem = selectionItem?.installation || selectionItem || {}
  const { location, highRise, parkingDifficult } = installationItem
  const { title } = card
  const locationText = location ? `. ${location}` : ''
  const highRiseText = highRise ? `. Stairs with no lift` : ''
  const parkingDifficultText = parkingDifficult ? `. Parking difficult` : ''

  return `${title}${locationText}${highRiseText}${parkingDifficultText}`
}
